import axios from 'axios';
import DaisyMessage, {
  NewDaisyMessageRequest,
  UpdateDaisyMessageRequest,
} from '../entity/daisy-message.entity';
import DaisyMessageFilter from '../entity/daisy-message-filter.entity';

const BASE_URL = '/api/daisy-messages';

export default class DaisyMessageService {
  public static search(
    filter: DaisyMessageFilter,
    page: number,
    size: number,
  ): Promise<any> {
    return axios.get(BASE_URL, {
      params: {
        messageType: filter.hasMessageType ? filter.messageType : null,
        language: filter.hasLanguage ? filter.language.trim() : null,
        active: filter.hasActive ? filter.active : null,
        page: page - 1,
        size,
      },
    });
  }

  public static getById(id: string): Promise<DaisyMessage> {
    return axios.get(`${BASE_URL}/${id}`)
      .then(response => new DaisyMessage(response.data));
  }

  public static create(request: NewDaisyMessageRequest): Promise<DaisyMessage> {
    return axios.post(BASE_URL, request)
      .then(response => new DaisyMessage(response.data));
  }

  public static update(id: string, request: UpdateDaisyMessageRequest): Promise<DaisyMessage> {
    return axios.put(`${BASE_URL}/${id}`, request)
      .then(response => new DaisyMessage(response.data));
  }

  public static delete(id: string): Promise<void> {
    return axios.delete(`${BASE_URL}/${id}`);
  }

  public static listLanguages(): Promise<string[]> {
    return axios.get(BASE_URL, { params: { page: 0, size: 500 } })
      .then(({ data }) => {
        const languages: string[] = data.content.map((item: any) => item.language);
        return Array.from(new Set(languages)).sort();
      });
  }
}
